import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';

import style from './style.module.css';

const Nav = ({ routes, open, className, onClick }) => {
  const customClassName = classNames(style.nav, 'nav', className, {
    [style['-open']]: open,
    [style['-close']]: !open,
  });

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  return (
    <nav className={customClassName}>
      <ul className="navigation-list">
        {routes.map(({ text, path, mobile, hash }) => {
          return (
            <li key={path} className={mobile ? 'hide-desktop' : null}>
              {hash ? (
                <NavHashLink
                  to={path}
                  className="nav-link"
                  onClick={onClick}
                  onKeyDown={onKeyDown}
                  role="link"
                >
                  {text}
                </NavHashLink>
              ) : (
                <NavLink
                  to={path}
                  className="nav-link"
                  onClick={onClick}
                  onKeyDown={onKeyDown}
                  role="link"
                >
                  {text}
                </NavLink>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

Nav.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  onClick: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
};

Nav.defaultProps = {
  className: null,
  open: false,
  onClick: () => {},
  routes: [],
};

export default Nav;

// export default () => <nav />;
